import { csv } from "d3-fetch";
import dayjs from "dayjs";
import DEATHS from "~/data/data.csv";

const loadData = () => {
  /* Fetch and parse files. */
  return Promise.all([csv(DEATHS)]).then(([deaths]) => {
    const data = {};
    // Reported deaths
    const cleanReported = deaths.map((item) => {
      const { date, reported } = item;
      const cleanDate = dayjs(date, "YYYY-MM-DD");
      const newDeaths = +reported >= 0 ? +reported : 0;
      return {
        date: cleanDate,
        newDeaths,
      };
    });
    // Occurred deaths
    const cleanOccurred = deaths.map((item) => {
      const { date, occurred } = item;
      const cleanDate = dayjs(date, "YYYY-MM-DD");
      const newDeaths = +occurred >= 0 ? +occurred : 0;
      return {
        date: cleanDate,
        newDeaths,
      };
    });
    data.reported = cleanReported;
    data.occurred = cleanOccurred;
    return data;
  });
};
export default loadData;
